import { startCase, toLower } from 'lodash'

export const titleCase = (str: string) => startCase(toLower(str))
